import { render, staticRenderFns } from "./SeminarPaymentBtn.vue?vue&type=template&id=37bb3cbe&"
import script from "./SeminarPaymentBtn.vue?vue&type=script&lang=js&"
export * from "./SeminarPaymentBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports